import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getShift } from 'lib/selectors/getShift';

const getShiftEnd = createSelector([getShift], (shift) => {
  return _get(shift, 'endAt');
});

export { getShiftEnd };
